'use strict';

import GraphQL from './graphql';

export default {
  createPending (name, email, organizationId, newOrganizationName) {
    let args = [];
    args.unshift(`name: "${name}"`);
    args.unshift(`email: "${email}"`);
    if (!!organizationId) {
      args.unshift(`organizationId: ${organizationId}`);
    }
    if (!!newOrganizationName) {
      args.unshift(`newOrganizationName: "${newOrganizationName}"`);
    }

    args = args.join(', ');

    const query = `mutation {
      createPendingUser(${args}) {
        id
        name
        email
      }
    }`;

    return GraphQL.post(query);
  }
};



// WEBPACK FOOTER //
// ./app/javascript/vue/services/users.js